export function generatePeriod(abbreviation: string, count: number): string[] {
	return new Array(count).fill(null).map((_, index) => `${abbreviation}${index + 1}`);
}
